import {
  MDBAlert,
  MDBIcon,
  MDBModalFooter,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";

import {
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
} from "mdb-react-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  getAddLocationMisc,
  getSpecificLocationData,
  updateLocation,
} from "../../../apiclients/streamsapi_bridge";
import { getGlobalLocation } from "../../../views/LoginNext";
import SaveChanges from "../../topviews/saveCancel";
import LocContactsSettings from "./LocContactsSettings";
import LocEmergencyNineOne from "./LocEmergencyNineOne";
import LocGeneralSettings from "./LocGeneralSettings";
import LocSchedule from "./LocSchedule";
import { useAdminContext } from "../../adminstore/Admin-Context";
import PopupLoader from "../../../views/popups/PopupLoader";
import { isFiveNineAccount } from "../../../views/Login";
import SeatLimitAlert from "../../../apiclients/SeatLimitAlert";

function LocationSettings(props) {
  const { t, i18n } = useTranslation();
  const [dedicatedNineOneNumbers, setDedicatedNineOneNumbers] = useState([]);
  const [billingGroups, setBillingGroups] = useState([]);

  const [locationdetails, setLocationdetails] = useState({});
  const [defaultValuess, setDefaultValuess] = useState({});
  const [defualtLocation, setDefualtLocation] = useState("false");

  const [allTime, setAllTime] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [internalError, setInternalError] = useState(false);

  const containerRef = useRef(null);
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const [statesList, setStatesList] = useState([]);
  const [technicalCheckBox, setTechnicalCheckBox] = useState(false);
  const [holidaysList, setHolidaysList] = useState([]);
  const [locationid, setLocationId] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [rerender, setReRender] = useState(false);
  const [sameAsPrimlaryFlag, setsameAsPrimlaryFlag] = useState(false);
  const [locationsList, setLocationsList] = useState([]);
  const [failedError, setFailedError] = useState("");
  const { setEdited } = useAdminContext();
  const [timeZone, settimeZone] = useState("");
  const [associteList, setassociteList] = useState([]);
  const [nineOneReq, setnineOneReq] = useState("");
  const [associateLoc, setassociateLoc] = useState(false);

  const toggleAssociate = () => setassociateLoc(!associateLoc);
  const [warningEdit, setwarningEdit] = useState(false);
  const toggleWarning = () => setwarningEdit(!warningEdit);
  const [emError, setEmError] = useState("");
  const [emValue, setEmValue] = useState(-1);
  const [isFiveNineAcc, setisFiveNineAcc] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [Warningalert, setWarningalert] = useState("");

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    setFocus,
    reset,
    getValues,
    watch,
    clearErrors,
    control,
    unregister,
  } = useForm({
    general: {
      location_name: "",
      street_addr1: "",
      street_addr2: "",
      city: "",
      state: 0,
      zip: "",
      make_def_loc: false,
      billing_grp: "",
    },
    contacts: {
      Primary: {
        email: "",
        fname: "",
        lname: "",
        number: "",
      },
      Technical: {
        same_as_primary: "",
        email: "",
        fname: "",
        lname: "",
        number: "",
      },
      Billing: {
        same_as_primary: "",
        email: "",
        fname: "",
        lname: "",
        number: "",
      },
    },
    schedule: {
      all_time: false,
      weekly_schedul: {
        sun: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        mon: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        tue: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        wed: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        thu: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        fri: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
        sat: {
          selected: false,
          from_time: "",
          to_time: "",
          twenty_four: false,
        },
      },
    },
    nine_one_one: {
      enable_nine_one_one: true,
      transfer_emg_locid: "",
      same_as_primary_contact: true,
      dedicated_nine_one_one_number: "",
      specific_location: "",
      nine_one_one_fname: "",
      nine_one_one_lname: "",
      nine_one_one_email: "",
      nine_one_one_number: "",
    },
  });
  const { isDirty, errors, dirtyFields } = formState;
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function fetchAddLocationMisc() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["add_location"],
        loc_id: props.locDetailsInfo.location_id,
      };

      const serverResponse = await getAddLocationMisc(params, siteid);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        // Process and set state based on responseData
        // const resultArray = (
        //   responseData.misc.add_location.dedicated_nine_one_one_number || []
        // ).map((num, index) => ({ id: index, text: num }));
        setDedicatedNineOneNumbers(
          responseData.misc.add_location.dedicated_nine_one_one_number || []
        );
        const transformedBillingGroups = (
          responseData.misc.add_location.billing_grp || []
        ).map((entry) => ({ text: entry.groupname, value: entry.groupid }));
        setBillingGroups(transformedBillingGroups);
        const transformedStatesList = (
          responseData.misc.add_location.state || []
        ).map((locations) => ({
          text: locations.statename,
          value: locations.stateid,
        }));
        setStatesList(responseData.misc.add_location.state || []);
        setLocationsList(transformedStatesList);
      }
    } catch (error) {
      console.error("[fetchAddLocationMisc] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    if (props.reqFromCallFlow) {
      setTimeout(() => {
        const section = document.getElementById("section-3");
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100); // Delay of 100ms
      // props.setreqFromCallFlow(false);
    }
  }, [props.reqFromCallFlow || successMessage]);

  useEffect(() => {
    if (props.reqFromCallFlow) {
      setTimeout(() => {
        const section = document.getElementById("section-3");
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100); // Delay of 100ms
      // props.setreqFromCallFlow(false);
    }
  }, [props.reqFromCallFlow || successMessage]);

  // Add any dependencies if needed

  async function getSpecificLocation() {
    try {
      // let locationId = '';
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      setIsLoading(true);
      const serverResponsedata = await getSpecificLocationData(
        siteid,
        props.locDetailsInfo.location_id
      );
      setIsLoading(false);

      if (!serverResponsedata.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const data = await serverResponsedata.json();
        if (data.status == "success") {
          console.log("data ::::: " + JSON.stringify(data));
          setLocationId(props.locDetailsInfo.location_id);
          setTechnicalCheckBox(
            data?.location_details?.contacts?.Technical?.same_as_primary ?? true
          );
          setAllTime(data.location_details.schedule.all_time);
          setHolidaysList(data.location_details.holidays ?? []);
          props.setLocDevicesList(data?.location_details?.devices ?? []);
          let {
            location_name,
            street_addr1,
            street_addr2,
            city,
            zip,
            state_name,
          } = data?.location_details?.general ?? {};
          props.setlocName(location_name ?? "");
          props.setlocAddress(
            street_addr1 +
              ", " +
              (street_addr2 ? street_addr2 + ", " : "") +
              city +
              ", " +
              (state_name ? state_name + ", " : "") +
              zip
          );
          // setWeeklySchedule(data.location_details.schedule.weekly_schedule);
          settimeZone(data?.location_details?.schedule?.timeZone ?? "");
          console.log(timeZone);
          setsameAsPrimlaryFlag(
            data?.location_details?.nine_one_one?.same_as_primary_contact ??
              true
          );

          setDefaultValuess({
            general: {
              location_name:
                data?.location_details?.general?.location_name ?? "",
              street_addr1: data?.location_details?.general.street_addr1 ?? "",
              street_addr2: data?.location_details?.general?.street_addr2 ?? "",
              city: data?.location_details?.general?.city ?? "",
              state: data?.location_details?.general?.state
                ? parseInt(data?.location_details?.general?.state)
                : 0,
              zip: data?.location_details?.general?.zip ?? "",
              make_def_loc:
                data?.location_details?.general?.make_def_loc != undefined
                  ? data.location_details.general.make_def_loc
                  : false,
              billing_grp: data?.location_details?.general?.billing_grp
                ? parseInt(data?.location_details?.general?.billing_grp)
                : -1,
            },
            contacts: {
              primary: {
                email: data?.location_details?.contacts?.primary?.email ?? "",
                fname: data?.location_details?.contacts?.primary?.fname ?? "",
                lname: data?.location_details?.contacts?.primary?.lname ?? "",
                number: data?.location_details?.contacts?.primary?.number ?? "",
              },
              technical: {
                same_as_primary:
                  data?.location_details?.contacts?.technical
                    ?.same_as_primary ?? true,
                email: data?.location_details?.contacts?.technical?.email ?? "",
                fname: data?.location_details?.contacts?.technical?.fname ?? "",
                lname: data?.location_details?.contacts?.technical?.lname ?? "",
                number:
                  data?.location_details?.contacts?.technical?.number ?? "",
              },
              billing: {
                same_as_primary:
                  data?.location_details?.contacts?.billing?.same_as_primary ??
                  true,
                email: data?.location_details?.contacts?.billing?.email ?? "",
                fname: data?.location_details?.contacts?.billing?.fname ?? "",
                lname: data?.location_details?.contacts?.billing?.lname ?? "",
                number: data?.location_details?.contacts?.billing?.number ?? "",
              },
            },
            schedule: {
              all_time: data?.location_details?.schedule?.all_time ?? false,
              weekly_schedule: {
                sun: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.sun
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.sun
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.sun
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.sun
                      ?.twenty_four ?? true,
                },
                mon: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.mon
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.mon
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.mon
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.mon
                      ?.twenty_four ?? true,
                },
                tue: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.tue
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.tue
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.tue
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.tue
                      ?.twenty_four ?? true,
                },
                wed: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.wed
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.wed
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.wed
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.wed
                      ?.twenty_four ?? true,
                },
                thu: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.thu
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.thu
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.thu
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.thu
                      ?.twenty_four ?? true,
                },
                fri: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.fri
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.fri
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.fri
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.fri
                      ?.twenty_four ?? true,
                },
                sat: {
                  selected:
                    data?.location_details?.schedule?.weekly_schedule?.sat
                      ?.selected ?? false,
                  from_time:
                    data?.location_details?.schedule?.weekly_schedule?.sat
                      ?.from_time ?? "8:00 AM",
                  to_time:
                    data?.location_details?.schedule?.weekly_schedule?.sat
                      ?.to_time ?? "5:00 PM",
                  twenty_four:
                    data?.location_details?.schedule?.weekly_schedule?.sat
                      ?.twenty_four ?? true,
                },
              },
            },
            nine_one_one: {
              transfer_emg_locid: "",
              enable_nine_one_one:
                data?.location_details?.nine_one_one?.enable_nine_one_one ??
                true,
              same_as_primary_contact:
                data?.location_details?.nine_one_one
                  ?.same_as_primary_contact !== undefined
                  ? data?.location_details?.nine_one_one
                      ?.same_as_primary_contact
                  : true,
              dedicated_nine_one_one_number:
                data?.location_details?.nine_one_one
                  ?.dedicated_nine_one_one_number ?? "",
              specific_location:
                data?.location_details?.nine_one_one?.specific_location ?? "",
              fname: data?.location_details?.nine_one_one?.fname ?? "",
              lname: data?.location_details?.nine_one_one?.lname ?? "",
              email: data?.location_details?.nine_one_one?.email ?? "",
              number: data?.location_details?.nine_one_one?.number ?? "",
            },
          });
        }
      }
      // setValue()
    } catch (error) {
      console.error("[fetchAddLocationMisk] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    if (defaultValuess && Object.keys(defaultValuess).length > 0) {
      reset(defaultValuess);
    }
  }, [defaultValuess]);

  useEffect(() => {
    if (
      ((props.locDetailsInfo &&
        props.locDetailsInfo.location_id &&
        props.locDetailsInfo.location_id !== "") ||
        rerender) &&
      props.isActive
    ) {
      getSpecificLocation();
      setisFiveNineAcc(isFiveNineAccount());
      fetchAddLocationMisc();
      setReRender(false);
    }
  }, [props.locDetailsInfo, props.isActive, rerender]);

  // useEffect(() => {
  //   if((props.locDetailsInfo && props.locDetailsInfo.location_id && props.locDetailsInfo.location_id !== "") || rerender) {
  //   setisFiveNineAcc(isFiveNineAccount());
  //   fetchAddLocationMisc();
  //   }
  // }, [props.locDetailsInfo, rerender]);

  const onCloseChanges = () => {
    reset();
  };

  const isModified =
    Object.keys(formState.dirtyFields).length > 0 ? true : false;

  console.log(
    "isModified :::::::::::::::::::: " + JSON.stringify(formState.dirtyFields)
  );

  useEffect(() => {
    setEdited(isModified);
  }, [isModified]);

  const onSaveChanges = async (data) => {
    try {
      //alert(JSON.stringify(dirtyFields));
      const country = data?.country ?? null;
      const { country:datacountry, ...filteredData } = data || {};
      const { country: fieldcountry, ...filteredDirtyFields } = dirtyFields || {};

      const modifiedData = extractModifiedFields(
        filteredData,
        filteredDirtyFields
      );
      //debugger;
      // alert(JSON.stringify(dirtyFields));
      // for (const field of Object.keys(dirtyFields)) {
      //   // Check if the field is dirty and exists in the data object
      //   if (dirtyFields[field] && data.hasOwnProperty(field)) {
      //     // If the field is an object, extract modified subfields
      //     if (typeof data[field] === "object" && !Array.isArray(data[field])) {
      //       modifiedData[field] = {};

      //       for (const subfield of Object.keys(dirtyFields[field])) {
      //         if (dirtyFields[field][subfield] && data[field].hasOwnProperty(subfield)) {
      //           if (
      //             typeof data[field][subfield] === "object" &&
      //             !Array.isArray(data[field][subfield])
      //           ) {
      //             modifiedData[field][subfield] = {};
      //             for (const subsubfield of Object.keys(
      //               dirtyFields[field][subfield]
      //             )) {
      //               if(dirtyFields[field][subfield][subsubfield] && data[field][subfield].hasOwnProperty(subsubfield)) {
      //               if(typeof data[field][subfield][subsubfield] === "object" && !Array.isArray(data[field][subfield][subsubfield])) {
      //                 modifiedData[field][subfield][subsubfield] = {};
      //                 for(const nestedsubfield of Object.keys(dirtyFields[field][subfield][subsubfield])){
      //                   modifiedData[field][subfield][subsubfield][nestedsubfield] = data[field][subfield][subsubfield][nestedsubfield];
      //                 }
      //               } else {
      //                 modifiedData[field][subfield][subsubfield] =  data[field][subfield][subsubfield];

      //               }
      //             }
      //               // modifiedData[field][subfield][subsubfield] =
      //               //   data[field][subfield][subsubfield];
      //             }
      //           } else {
      //             modifiedData[field][subfield] = data[field][subfield];
      //           }
      //         }
      //       }
      //     } else {
      //       // If it's not an object, add the entire field
      //       modifiedData[field] = data[field];
      //     }
      //   }
      // }

      if (modifiedData) {
        if (modifiedData?.nine_one_one?.enable_nine_one_one) {
          modifiedData.nine_one_one.same_as_primary_contact =
            data.nine_one_one.same_as_primary_contact;
        }
        modifiedData.reqid = 37;
        modifiedData.siteid = JSON.parse(
          sessionStorage.getItem("admin_session")
        ).siteid;
        modifiedData.location_id = props.locDetailsInfo.location_id;
        // modifiedData.code = hgGeneralInfo.code;
        console.log(
          "location Edit feild json ::: " + JSON.stringify(modifiedData)
        );
        setIsLoading(true);

        let response = await updateLocation(modifiedData, country);
        setIsLoading(false);
        console.log("response before::::: " + JSON.stringify(response));
        let resdata = await response.json();
        console.log("response ::::: " + JSON.stringify(resdata));
        if (response.status === 200) {
          if (resdata.emergency_assoc) {
            setEmValue(-1);
            setassociateLoc(true);
            setassociteList(resdata.emergency_assoc);
          } else if (resdata.nineoo_required) {
            setwarningEdit(true);
            setnineOneReq(resdata.nineoo_required);
          } else {
            if (
              resdata.nineoo_profile_limit_exceed &&
              resdata.nineoo_profile_limit_exceed !== ""
            ) {
              setWarningalert(resdata.nineoo_profile_limit_exceed);
              setShowWarning(true);
            } else {
              setSuccessMessage(resdata.message); // success pop up message.
              setReRender(true); // Re- Rednering the child componenet in order to stay in the same page after saving with latest updated data.
              await getGlobalLocation();
              if (
                modifiedData.hasOwnProperty("schedule") &&
                props.reqFromCallFlow
              ) {
                if (window.opener && window.opener.receiveMessageFromChild) {
                  window.opener.receiveMessageFromChild(1); // Send a message to the parent
                }
                props.setreqFromCallFlow(false);
                window.close();
              }
            }
          }
        } else if (response.status === 400) {
          if (resdata.message?.errors) {
            resdata.message.errors.forEach((err) => {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
            });
          }
        } else if (response.status === 500) {
          setInternalError(true);
          setFailedError(resdata?.message ?? "");
          setReRender(true);
        }
      }
    } catch (e) {
      console.log(`Unable to send update Hunt User to API:${e}`);
      setInternalError(true);
    }
  };

  function extractModifiedFields(data, dirtyFields, modifiedData = {}) {
    for (const field of Object.keys(dirtyFields)) {
      console.log("modifiedData :::::::: " + JSON.stringify(modifiedData));
      console.log("field :::: " + field);
      if (field === "schedule") {
        const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        for (const day of days) {
          // Check if the day exists in dirtyFields and has modifications
          if (dirtyFields[field]?.weekly_schedule?.[day]) {
            // Initialize if not exists
            if (!modifiedData[field]) {
              modifiedData[field] = { weekly_schedule: {} };
            }
            if (!modifiedData[field].weekly_schedule[day]) {
              modifiedData[field].weekly_schedule[day] = {};
            }

            // If twenty_four is modified (regardless of value), include from_time and to_time
            if (
              dirtyFields[field].weekly_schedule[day].twenty_four !== undefined
            ) {
              modifiedData[field].weekly_schedule[day].twenty_four =
                data[field].weekly_schedule[day].twenty_four;
              modifiedData[field].weekly_schedule[day].from_time =
                data[field].weekly_schedule[day].from_time;
              modifiedData[field].weekly_schedule[day].to_time =
                data[field].weekly_schedule[day].to_time;
            }
          }
        }
      }
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        if (typeof data[field] === "object" && !Array.isArray(data[field])) {
          modifiedData[field] = {};
          extractModifiedFields(
            data[field],
            dirtyFields[field],
            modifiedData[field]
          );
        } else {
          modifiedData[field] = data[field];
        }
      }
    }
    return modifiedData;
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, []);

  const handleOk = () => {
    setValue("nine_one_one.enable_nine_one_one", false, { shouldDirty: true });
    unregister("nine_one_one")
    warningToggle();
  };

  return (
    <>
      <MDBRow>
        <MDBCol
          size="2"
          md="2"
          lg="2"
          sm="12"
          className="col-sm-100 pr-0 leftTabs"
        >
          <MDBScrollspy container={containerRef}>
            <MDBScrollspyLink targetRef={section1}>
              {t("general")}
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section2}>
              {t("contacts")}
            </MDBScrollspyLink>
            <MDBScrollspyLink targetRef={section3}>
              {" "}
              {t("weeklyschedule")}
            </MDBScrollspyLink>
            {!isFiveNineAcc && (
              <MDBScrollspyLink targetRef={section4}>
                {" "}
                {t("emergency911")}
              </MDBScrollspyLink>
            )}
          </MDBScrollspy>
        </MDBCol>

        <MDBCol
          size="12"
          md="10"
          sm="12"
          pr-0
          className="col-sm-100 pr-0 leftTabContent"
        >
          <div ref={containerRef} className="scrollspy-example">
            <section ref={section1} id="section-1">
              <LocGeneralSettings
                register={register}
                locationsList={locationsList}
                statesList={statesList}
                billingGroups={billingGroups}
                defualtLocation={defualtLocation}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
                clearErrors={clearErrors}
              />
            </section>
            <section ref={section2} id="section-2">
              <LocContactsSettings
                register={register}
                setValue={setValue}
                getValues={getValues}
                errors={errors}
              />
            </section>
            <section ref={section3} id="section-3">
              <LocSchedule
                register={register}
                setValue={setValue}
                getValues={getValues}
                errors={errors}
                unregister={unregister}
                holidaysList={holidaysList}
                locationid={locationid}
                setSuccessMessage={setSuccessMessage}
                reqFromCallFlow={props.reqFromCallFlow}
                setreqFromCallFlow={props.setreqFromCallFlow}
                clearErrors={clearErrors}
                timezone={timeZone}
                watch={watch}
              />
            </section>
            <div className="routing-border mt-2"></div>
            <section
              ref={section4}
              id="section-4"
              style={{ paddingBottom: "47vh" }}
            >
              <LocEmergencyNineOne
                register={register}
                setValue={setValue}
                getValues={getValues}
                errors={errors}
                dedicatedNineOneNumbers={dedicatedNineOneNumbers}
                sameAsPrimlaryFlag={sameAsPrimlaryFlag}
                watch={watch}
              />
            </section>
          </div>
          {isModified && (
            <SaveChanges
              onClose={onCloseChanges}
              isFieldModified={isModified}
              onSave={(e) => {
                e.preventDefault();
                handleSubmit(onSaveChanges)();
              }}
            />
          )}
        </MDBCol>
      </MDBRow>

      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={3000}
          onClose={() => setInternalError(false)}
        >
          {failedError ? failedError : "Internal Server Error"}
        </MDBAlert>
      )}

      {associateLoc && (
        <PopupLoader
          title={"Disable 911"}
          content={
            <>
              {associteList && associteList.length > 0 && (
                <>
                  <div className="tel-numbers mt-1">
                    <strong>{t("select911loc")}</strong>
                  </div>
                  <span className="phrecording">
                    {t("Search a list of all 911-Enabled Locations.")}
                  </span>
                  <div className="mb-0 w-100">
                    <div className="w-100">
                      <select
                        className="form-select form-control w-100"
                        value={emValue}
                        name="San Jose"
                        onChange={(e) => {
                          e.preventDefault();
                          setEmValue(parseInt(e.target.value));
                        }}
                      >
                        <option value={-1}>--Select Location--</option>
                        {associteList &&
                          associteList.map((em) => (
                            <option value={parseInt(em.nineoo_loc_id)}>
                              {em.loc_name}
                              {em.default_loc ? " (default)" : ""}
                            </option>
                          ))}
                      </select>
                      {emError && <div style={{ color: "red" }}>{emError}</div>}
                    </div>
                  </div>

                  <MDBModalFooter className="p-0 pt-2 mt-3">
                    <MDBBtn
                      color="secondary"
                      onClick={(e) => {
                        setValue("nine_one_one.enable_nine_one_one", true, {
                          shouldDirty: true,
                        });
                        toggleAssociate();
                      }}
                    >
                      {t("cancel")}
                    </MDBBtn>
                    <MDBBtn
                      // disabled={isloading}
                      onClick={(e) => {
                        e.preventDefault();
                        if (emValue !== -1) {
                          setEmError("");
                          setValue("nine_one_one.transfer_emg_locid", emValue, {
                            shouldDirty: true,
                          });
                          toggleAssociate();
                        } else {
                          setEmError(
                            "Please select an emergency 911 location."
                          );
                        }
                      }}
                    >
                      {" "}
                      {t("ok")}{" "}
                    </MDBBtn>
                  </MDBModalFooter>
                </>
              )}
            </>
          }
          className={""}
          onShow={setassociateLoc}
          onClose={(e) => {
            e?.preventDefault();
            setValue("nine_one_one.enable_nine_one_one", true, {
              shouldDirty: true,
            });
            toggleAssociate();
          }}
        />
      )}
      {warningEdit && (
        <PopupLoader
          title={"Warning"}
          content={
            <>
              {/* <strong>{t("select911loc")}</strong> */}
              <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                <MDBIcon
                  fas
                  icon="exclamation-triangle"
                  className="me-3 fs-5 mt-1"
                  color="warning"
                />
                <p>
                  {nineOneReq}
                  {/* Account must have at least one 911 profile. */}
                </p>
              </div>

              <MDBModalFooter className="p-0 pt-2 mt-3">
                <MDBBtn
                  onClick={(e) => {
                    e?.preventDefault();
                    setValue("nine_one_one.enable_nine_one_one", true, {
                      shouldDirty: true,
                    });
                    // unregister("nine_one_one.enable_nine_one_one");
                    toggleWarning();
                  }}
                >
                  {" "}
                  {t("ok")}{" "}
                </MDBBtn>
              </MDBModalFooter>
            </>
          }
          className={""}
          onShow={setwarningEdit}
          onClose={(e) => {
            e?.preventDefault();
            setValue("nine_one_one.enable_nine_one_one", true, {
              shouldDirty: true,
            });
            toggleWarning();
          }}
        />
      )}

      {showWarning && (
        <SeatLimitAlert
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          warningMessage={Warningalert}
          onOk={handleOk}
        />
      )}
    </>
  );
}

export default LocationSettings;
